module.exports = __webpack_public_path__ + "img/tarj2-3.be03ac33.png";